import Cookies from 'js-cookie';
export const getCookie = (name) => {
        const token = Cookies.get(name);
        console.log('token', token)
        if(token) {
        return token
       } else {
           return null
       }
    // var ca = document.cookie.split(';');
    // console.log("获取cookie,现在循环")
    // for (var i = 0; i < ca.length; i++) {
    //     var c = ca[i];
    //     console.log(c)
    //     while (c.charAt(0) == ' ') c = c.substring(1);
    //     if (c.indexOf(name) != -1) {
    //         return c.substring(name.length, c.length);
    //     }
    // }
    // return '';
}
